import React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

const SecurityQuestionChange = (props) => {
  return (
    <div className='popup-box'>
        <h4 className="title">{props.t('information')}</h4>
        <p>{props.t('successfully_changed_the_security_question')}</p>
    </div>
  )
}

SecurityQuestionChange.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(SecurityQuestionChange);